import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

// ---------------------
// 1️⃣ Upload Doctor Document File (PDF, etc.)
// ---------------------
export const uploadDoctorMedia = createAsyncThunk(
  "media/uploadDoctorMedia",
  async ({ file_data, filename, mime_type, docType }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        process.env.REACT_APP_API_URL + APP_PATH.uploadDoctorMedia,
        {
          file_data,
          filename,
          mime_type,
          docType,
        },
      );

      // Use localized success message
      const message = getLocalizedMessage(response, i18n);
      toast.success(message);

      return response.data.data; // contains file_url, filename, etc.
    } catch (error) {
      console.error("Error uploading doctor document:", error);

      // Use localized error message
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);

      return rejectWithValue(error.response?.data || i18n.t("toast.uploadFailed"));
    }
  },
);

// ---------------------
// 2️⃣ Upload Avatar (Profile Photo)
// ---------------------
export const uploadAvatar = createAsyncThunk(
  "media/uploadAvatar",
  async (
    { file_data, filename, mime_type, description },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        process.env.REACT_APP_API_URL + APP_PATH.uploadAvatar,
        {
          file_data,
          filename,
          mime_type,
          description,
        },
      );

      // Use localized success message
      const message = getLocalizedMessage(response, i18n);
      toast.success(message);

      return response.data.data;
    } catch (error) {
      console.error("Error uploading avatar:", error);

      // Use localized error message
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);

      return rejectWithValue(error.response?.data || i18n.t("toast.uploadFailed"));
    }
  },
);
